import api from '../../../services/Api';
import { IAuditoriaAssetRecoveryResultado } from '../interfaces/IAuditoriaAssetRecovery';

export const AuditoriaAssetRecoveryService = {
  buscarResultado: async (params: { empresaId: number; periodo: string | undefined })
    : Promise<IAuditoriaAssetRecoveryResultado> => {
    const response = await api.get<IAuditoriaAssetRecoveryResultado>(
      'auditoria-asset-recovery/resultado',
      { params: { empresaIds: params.empresaId, periodo: params.periodo } }
    );
    return response.data;
  },
};
